import React, { type ReactNode, useMemo } from 'react';
import { ColorPickerContext, type ColorPickerValues } from './context';
import Header from './Header';
import Bar from './Bar';
import Reset from './Reset';

interface Props extends ColorPickerValues {
  className?: string;
  children: ReactNode;
}

function ColorPicker({ className, colorString, onChange, children }: Props) {
  const value = useMemo(
    () => ({ colorString, onChange }),
    [colorString, onChange]
  );
  return (
    <ColorPickerContext.Provider value={value}>
      <div className={className}>{children}</div>
    </ColorPickerContext.Provider>
  );
}

ColorPicker.Header = Header;
ColorPicker.Bar = Bar;
ColorPicker.Reset = Reset;

export default ColorPicker;
